/* eslint-disable @typescript-eslint/unbound-method, no-param-reassign */ import { createContext } from "react";
import { noop, noopFalse } from "./utils";
export const NavigationListContext = /*#__PURE__*/ createContext({
    dispatchCommand: noopFalse,
    forceMultiselect: false,
    setForceMultiselect: noop,
    mouseInputModeRef: {
        current: false
    },
    registerGlobalHandler () {
        return noop;
    },
    registerList () {
        return noop;
    },
    lockNavigation: noop,
    activeCoord: null,
    setActiveCoord: noop,
    multiselectCoords: null,
    setMultiselectCoords: noop,
    toggleItem: noop,
    currentlyActiveCommands: []
});
